var map = {
	"./CLOSED.png": 1152,
	"./COMPLETED.png": 3705,
	"./DEVELOPING.png": 4797,
	"./HOVER.png": 6456,
	"./NEW.png": 7948,
	"./REVIEWING.png": 3298,
	"./Rectangle.png": 9989,
	"./Rectangle_bottom.png": 4283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7099;